import React from 'react';
import { Box, SxProps, useTheme } from '@mui/material';

type Props = {
    sx?: SxProps;
};
export const VerticalDivider: React.FunctionComponent<Props> = function ({ sx }) {
    const theme = useTheme();
    const verticalDividerStyle = {
        maxWidth: '1px',
        minWidth: '1px',
        height: '55px',
        backgroundColor: theme.palette.divider,
        ...sx,
    };

    return (
        <Box
            sx={verticalDividerStyle}
            data-testid="VerticalDivider-test-id"
        />
    );
};
